/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * Run `yarn nx run order:generate-types` and edit the `.graphql` files
 *
 * See codegen config in .graphqlrc.yml for details
 */

/* eslint-disable unicorn/no-abusive-eslint-disable */ /* eslint-disable eslint-comments/no-unlimited-disable */ /* eslint-disable */ /* cspell:disable */

import * as Types from '../../../graphql/types';

import { ExecutionResult } from 'graphql';
import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type ScanToPayBillingAccountsQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type ScanToPayBillingAccountsQuery = {
  readonly __typename?: 'Query';
  readonly currentCustomer: {
    readonly __typename?: 'Customer';
    readonly id: string;
    readonly billingAccounts: ReadonlyArray<{
      readonly __typename?: 'BillingAccount';
      readonly id: string;
      readonly description: string;
      readonly nickname: string | null;
      readonly isDefault: boolean;
      readonly cardType: Types.CardType;
      readonly expirationState: Types.ExpirationState;
    }>;
  } | null;
};

export type CustomerPassQueryVariables = Types.Exact<{ [key: string]: never }>;

export type CustomerPassQuery = {
  readonly __typename?: 'Query';
  readonly customerPass: {
    readonly __typename?: 'CustomerPass';
    readonly authenticationToken: string | null;
    readonly url: string | null;
  } | null;
};

export const scanToPayBillingAccountsQueryMock: ExecutionResult<ScanToPayBillingAccountsQuery> =
  {
    data: {
      currentCustomer: {
        id: 'e509e6ea-9fee-442a-9962-587ce7190430',
        billingAccounts: [
          {
            id: 'da7a7163-ba7e-4da9-ae8a-185e3da00a9a',
            description: 'Hello World',
            nickname: 'Hello World',
            isDefault: false,
            cardType: 'AMERICAN_EXPRESS',
            expirationState: 'EXPIRED',
          },
          {
            id: '7534319d-0806-40b5-9aa2-50f9c4016b1b',
            description: 'Hello World',
            nickname: 'Hello World',
            isDefault: true,
            cardType: 'AMERICAN_EXPRESS',
            expirationState: 'EXPIRED',
          },
        ],
      },
    },
  };

export const customerPassQueryMock: ExecutionResult<CustomerPassQuery> = {
  data: {
    customerPass: { authenticationToken: 'Hello World', url: 'Hello World' },
  },
};

export const ScanToPayBillingAccountsDocument = gql`
  query scanToPayBillingAccounts {
    currentCustomer {
      id
      billingAccounts {
        id
        description
        nickname
        isDefault
        cardType
        expirationState
      }
    }
  }
`;

export function useScanToPayBillingAccountsQuery(
  options?: Omit<
    Urql.UseQueryArgs<ScanToPayBillingAccountsQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    ScanToPayBillingAccountsQuery,
    ScanToPayBillingAccountsQueryVariables
  >({ query: ScanToPayBillingAccountsDocument, ...options });
}
export const CustomerPassDocument = gql`
  query customerPass {
    customerPass {
      authenticationToken
      url
    }
  }
`;

export function useCustomerPassQuery(
  options?: Omit<Urql.UseQueryArgs<CustomerPassQueryVariables>, 'query'>,
) {
  return Urql.useQuery<CustomerPassQuery, CustomerPassQueryVariables>({
    query: CustomerPassDocument,
    ...options,
  });
}
